export type NetworkEnv = "testnet" | "mainnet";

export const NETWORK_ENV_KEY = "nanomNetworkEnv";

export function getNetworkEnv(): NetworkEnv {
  try {
    const v = (localStorage.getItem(NETWORK_ENV_KEY) || "").trim().toLowerCase();
    return v === "mainnet" ? "mainnet" : "testnet";
  } catch {
    return "testnet";
  }
}

export function setNetworkEnv(env: NetworkEnv): void {
  localStorage.setItem(NETWORK_ENV_KEY, env === "mainnet" ? "mainnet" : "testnet");
}

export type NetworkEnvRow = {
  code: NetworkEnv;
  title: string;
  createEnabled: boolean;
  nmcChainId: number | null;
  bscChainId: number | null;
};

export type NetworkEnvStatus = {
  ok: boolean;
  default: NetworkEnv;
  active: NetworkEnvRow[];
};
